import { connect } from 'react-redux';

import UpdateStatusModal from './UpdateStatusModal';
import { quickUpdateSubStatus } from 'actions/quickSubs';
import { getQuickSyncStatusResponse } from 'reducers';

const mapStateToProps = (state, { sub }) => {
  return {
    response: getQuickSyncStatusResponse(state, sub?.id),
  };
};

const mapDispatchToProps = {
  updateSubStatus: quickUpdateSubStatus,
};

const QuickUpdateStatusModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateStatusModal);

export default QuickUpdateStatusModal;
